import React from 'react';
import { DropdownIndicatorProps, components } from 'react-select';
import { down, search } from 'static/icons/resizable';
import { Icon } from 'view/atoms';

export function DropdownIndicatorArrow<T>() {
  return (props: DropdownIndicatorProps<T>) => (
    <components.DropdownIndicator {...props}>
      <Icon src={down} alt='drop-down indicator' />
    </components.DropdownIndicator>
  );
}

export function DropdownIndicatorSearch<T>() {
  return (props: DropdownIndicatorProps<T>) => (
    <components.DropdownIndicator {...props}>
      <Icon src={search} alt='search city' />
    </components.DropdownIndicator>
  );
}
